// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__LmTTI","actions":"GroupTable_actions__2EXYR","deleteModalFooter":"GroupTable_deleteModalFooter__1Ey7H"};